import React, { useState } from 'react';
import { Avatar, Tooltip } from '@mantine/core';
import { UserInfo } from '../types';
import styles from './components.module.scss';

interface UserSectionProps {
  user?: UserInfo;
}

export const UserSection: React.FC<UserSectionProps> = ({ user }) => {
  const [userName] = useState<string | undefined>(user?.name);
  const [userInitial] = useState<string | undefined>(
    user?.name ? user.name.charAt(0).toUpperCase() : undefined
  );

  if (!userName) return null;

  return (
    <div className={styles.userSection}>
      <Avatar size="xs" radius="xl" variant="filled" className={styles.userSection__avatar}>
        {userInitial}
      </Avatar>
      <Tooltip label={userName} position="top" disabled={userName.length < 15}>
        <span className={styles.userSection__text}>{userName}</span>
      </Tooltip>
    </div>
  );
};
